import { render, staticRenderFns } from "./CandidatesExchangeItem.vue?vue&type=template&id=244015ba&lang=pug&"
import script from "./CandidatesExchangeItem.vue?vue&type=script&lang=js&"
export * from "./CandidatesExchangeItem.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesExchangeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
